export class VideoPosterItem {
    private element: HTMLImageElement;

    constructor(element: HTMLImageElement) {
        this.element = element;
        this.init();
    }

    init() {
        const posterId = this.element.getAttribute('data-poster-id');
        const videoType = this.element.getAttribute('data-video-type');
        
        if (!posterId || !videoType) return;

        switch (videoType) {
            case 'youtube':
                this.loadYouTubePoster(posterId);
                break;
            case 'vimeo':
                this.loadVimeoPoster(posterId);
                break;
            case 'jwplayer':
                this.loadJWPoster(posterId);
                break;
        }
    }

    loadYouTubePoster(videoId: string) {
        this.element.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }

    async loadVimeoPoster(videoId: string) {
        const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`);
        const data = await response.json();
        if (data.thumbnail_url) {
            this.element.src = data.thumbnail_url;
        }
    }

    loadJWPoster(videoId: string) {
        this.element.src = `https://cdn.jwplayer.com/v2/media/${videoId}/poster.jpg`;
    }
}